import { render, staticRenderFns } from "./ManageBank.vue?vue&type=template&id=8065af74&"
import script from "./ManageBank.vue?vue&type=script&lang=js&"
export * from "./ManageBank.vue?vue&type=script&lang=js&"
import style0 from "./ManageBank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports